var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3787 8.64981C18.7394 6.27744 21.2653 4.8143 24.0001 4.8143C26.735 4.8143 29.2609 6.27744 30.6216 8.64981L43.6863 31.4286C44.2664 32.4398 44.5716 33.5852 44.5716 34.751C44.5716 38.4387 41.5819 41.4285 37.8941 41.4285H10.1064C6.41839 41.4285 3.42871 38.4387 3.42871 34.751C3.42871 33.5852 3.73389 32.4398 4.31383 31.4286L17.3787 8.64981ZM24.0001 8.24287C22.4937 8.24287 21.1023 9.04883 20.3528 10.3556L7.28795 33.1344C7.00577 33.6264 6.85728 34.1837 6.85728 34.751C6.85728 36.5455 8.31196 37.9999 10.1064 37.9999H37.8941C39.6883 37.9999 41.143 36.5455 41.143 34.751C41.143 34.1837 40.9945 33.6264 40.7124 33.1344L27.6475 10.3556C26.898 9.04883 25.5066 8.24287 24.0001 8.24287Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0004 15.0485C24.9472 15.0485 25.7147 15.816 25.7147 16.7628V25.7512C25.7147 26.698 24.9472 27.4655 24.0004 27.4655C23.0537 27.4655 22.2861 26.698 22.2861 25.7512V16.7628C22.2861 15.816 23.0537 15.0485 24.0004 15.0485ZM24.0004 30.8401C24.9472 30.8401 25.7147 31.6076 25.7147 32.5544V33.3689C25.7147 34.3156 24.9472 35.0832 24.0004 35.0832C23.0537 35.0832 22.2861 34.3156 22.2861 33.3689V32.5544C22.2861 31.6076 23.0537 30.8401 24.0004 30.8401Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.caa8e2e488092375e07ef5e1e56f2a5d.svg";
export { ForwardRef as ReactComponent };